<template>
  <Teleport to="#panels" v-if="$props.show">
    <div @click.prevent="closePanel" class="fixed inset-0 bg-white opacity-10 flex">
    </div>

    <!-- Выезжающая панель -->
    <div id="panel1"
         class="fixed inset-y-0 inset-x-[100%] right-0 w-[87%] text-gray-100 shadow-lg transform -translate-x-full transition-transform duration-300 ease-in-out z-50"
    style="background-color: rgb(33, 45, 51);">
      <div class="p-4" @click.prevent>
        <h2 class="text-xl font-bold mb-4">{{ $props.title }}</h2>
        <div class="pt-4 text-left text-gray-100">
          <slot></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'LeftPanel',
  props: {
    title: {
      type: String,
      required: true,
      default: 'Panel Title',
    },
    show: {
      type: Boolean,
    }
  },
  methods: {
    closePanel() {
      this.$emit('close')
    },
    done() {
      this.$emit('done')
    }
  },
  mounted() {
    //this.load()
  }
}
</script>

<style scoped>

</style>